import React from 'react'
import styled from 'styled-components/macro'
import { getGelTokens } from '@tal-gel/theming'

import Caption from '../Typography/Caption'

const Component = styled.div`
  width: ${(props) => (props.current / props.max) * 100}%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const Border = styled.div`
  height: 8px;
  width: 100%;
  background-color: ${() => getGelTokens().brand.brandColorPrimary1};
  border-radius: 4px;
`

const Step = ({ current, max }) => (
  <Component current={current} max={max}>
    <Border />
    <Caption light>{Math.round((current / max) * 100)}%</Caption>
  </Component>
)

export default Step
